module.exports = __webpack_public_path__ + "static/media/HomeIcon-1.220e5c2d.png";